import { Controller } from "@hotwired/stimulus"
import { Modal } from "../utils/modal"

export default class extends Controller {
    connect() {
        const { timeoutAt } = this.element.dataset;
        const timeoutAtDate = new Date(timeoutAt);

        this.timeoutAfterMs = timeoutAtDate - new Date();

        this.warning_shown = false;
        this.timer = this.startTimer(timeoutAtDate);

        if (!globalThis.sessionTimeoutTimer) {
            globalThis.sessionTimeoutTimer = [];
        }
        globalThis.sessionTimeoutTimer.push(this);
    }

    disconnect() {
        if (this.timer) {
            clearInterval(this.timer);
        }
        this.timer = null;
        globalThis.sessionTimeoutTimer = globalThis.sessionTimeoutTimer.filter((value) => value !== this);
    }

    reset() {
        const timeoutAtDate = new Date();
        timeoutAtDate.setMilliseconds(timeoutAtDate.getMilliseconds() + this.timeoutAfterMs);

        if (this.timer) {
            clearInterval(this.timer);
        }

        this.timer = this.startTimer(timeoutAtDate);
    }

    startTimer(timeoutAtDate) {
        const controller = this;
        const { countdownTemplate, warningTemplate } = this.element.dataset;
        const timer = setInterval(function () {
            const difference = (timeoutAtDate - new Date()) / 1000;
            let minutes = parseInt(difference / 60, 10);
            let seconds = parseInt(difference % 60, 10);

            minutes = String(minutes).padStart(2, '0');
            seconds = String(seconds).padStart(2, '0');

            controller.element.textContent = `${countdownTemplate} (${minutes}:${seconds})`;

            // 5mins before it ends, we do warn the user
            if (!controller.warning_shown && difference <= 300) {
                controller.warning_shown = true;
                Modal.danger({
                    title: window.I18n.modal.danger.title,
                    message: warningTemplate,
                    confirmText: window.I18n.general.okay,
                    cancelText: window.I18n.general.cancel,
                });
            }

            if (difference <= 0) {
                location.reload();
            }
        }, 1000);

        return timer;
    }
}